import React, { useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import $ from "jquery";

import "datatables.net-dt/js/dataTables.dataTables.js";
import "datatables.net-responsive-dt/js/responsive.dataTables.js";
import "datatables.net-responsive-dt/css/responsive.dataTables.css";
import { API_URL } from "..";

const AssetsListLayer = ({ assetsData }) => {
  const history = useNavigate();

  const handleDelete = async (id) => {
    try {
      const response = await fetch(`${API_URL}/api/assets/delete/${id}`, {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
      });

      const res = await response.json();

      if (res.success) {
        window.location.reload();
      }
    } catch (e) {
      console.error("Delete failed", e);
    }
  };

  useEffect(() => {
    const table = $("#assetsTable").DataTable({
      data: assetsData,
      responsive: true,
      pageLength: 10,
      destroy: true,
      columns: [
        { data: "title" },
        {
          data: "costPrice",
          render: (d) => `<span>${parseFloat(d).toFixed(2)}</span>`,
        },
        { data: "quantity" },
        { data: "addedOn" },
        {
          data: null,
          render: function (data, type, row) {
            return `
          <div class="dropdown">
            <button class="dropdown-toggle" type="button" data-bs-toggle="dropdown">
              <i class="ph ph-list"></i>
            </button>
            <ul class="dropdown-menu">
              <li><a class="dropdown-item view-btn" data-id="${row.id}" style="cursor:pointer"><i class="ph ph-eye"></i> View</a></li>
              <li><a class="dropdown-item edit-btn" data-id="${row.id}" style="cursor:pointer"><i class="ph ph-pencil"></i> Edit</a></li>
              <li><a class="dropdown-item delete-btn" data-id="${row.id}" style="cursor:pointer"><i class="ph ph-trash"></i> Delete</a></li>
            </ul>
          </div>
        `;
          },
          title: "Actions",
          orderable: false,
        },
      ],
    });

    $("#assetsTable tbody").on("click", ".edit-btn", function () {
      const id = $(this).data("id");
      history(`/edit-asset/${id}`);
    });

    $("#assetsTable tbody").on("click", ".view-btn", function () {
      const id = $(this).data("id");
      history(`/view-asset/${id}`);
    });

    $("#assetsTable tbody").on("click", ".delete-btn", function () {
      const id = $(this).data("id");
      handleDelete(id);
    });

    return () => table.destroy(true);
  }, [assetsData]);

  return (
    <div className="card basic-data-table">
      <div className="card-header">
        <div className="row">
          <h5 className="col-md-6 card-title mb-0"></h5>
          <div className="col-md-6 text-end">
            <Link className="btn btn-info" to={"/add-asset"}>
              Add New
            </Link>
          </div>
        </div>
      </div>

      <div className="card-body">
        <table className="table bordered-table mb-0" id="assetsTable">
          <thead>
            <tr>
              <th>Title</th>
              <th>Cost Price</th>
              <th>Quantity</th>
              <th>Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>{/* Filled by DataTables */}</tbody>
        </table>
      </div>
    </div>
  );
};

export default AssetsListLayer;
